import styled from "@emotion/styled";
import { TitleWithLine, extractProperty } from "ui";
import { sharedColors } from "ui/theme/colors";
import AccordionFaq from "./AccordionFaq";

const StyledContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 56px;
    margin-bottom: 50px;
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-top: 80px;
    margin-bottom: 68px;
  }
`
const StyledAccordionContainer = styled.div`
  margin-top: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 30px;
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-top: 40px;
  }
`
const Padding = styled.div`
  padding: 0 28px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 220px;
  }
`



type Props = {
  data: any,
}
function AccordionFaqWrapper({ data }: Props) {

  const mainTitle = extractProperty(data, "mainTitle")
  const accordionInner = extractProperty(data, "accordionInner")

  return (
    <Padding>
      <StyledContainer>
        <TitleWithLine
          titleColor={sharedColors.black}
          title={mainTitle}
          titleFontSize={64}
          mobileTitleFontSize={36}
          marginTop={32}
          component={"h2"}
        />
        <StyledAccordionContainer>
          <AccordionFaq accordion={accordionInner} titleProp="accordionTitle" contentProp="accordionContent" />
        </StyledAccordionContainer>
      </StyledContainer>
    </Padding>
  );
}

export default AccordionFaqWrapper;
